
import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { GlobalStyles, Box } from '@bigcommerce/big-design';

import Header from './components/Header';
import FeesPage from './pages/FeesPage';
import CreateEditFeePage from './pages/CreateEditFeePage';
import SetupCheckoutPage from './pages/SetupCheckoutPage';
import SettingsPage from './pages/SettingsPage';
import StartupRedirect from './pages/StartupRedirect';
import TrialExpiredPage from './pages/TrialExpiredPage';
import LandingPage from './pages/LandingPage';
import SupportPage from './pages/SupportPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import { getAuthToken, getStoreHash } from './api/config';

function App() {
  // Check if user has BigCommerce authentication
  const isAuthenticated = !!getAuthToken();
  const storeHash = getStoreHash();

  // null while loading - treated as "not gated yet" below, so there's no
  // paywall flash before this resolves. Settings itself is never gated, so a
  // trial-expired merchant can always reach the Subscribe button there.
  const [billing, setBilling] = useState(null);

  useEffect(() => {
    if (!isAuthenticated || !storeHash) return;

    fetch(`/api/subscription?store_hash=${storeHash}`)
      .then((res) => res.json())
      .then(setBilling)
      .catch((err) => console.error('Failed to load billing status:', err));
  }, [isAuthenticated, storeHash]);

  const trialGated = billing?.configured && billing.entitled === false;

  // Check if user is on support page (accessible without auth)
  const isSupportPage = window.location.pathname === '/support';
  const isPrivacyPage = window.location.pathname === '/privacy';

  // Show support page for /support URL (accessible to everyone)
  if (isSupportPage) {
    return <SupportPage />;
  }

  // Show privacy policy page for /privacy URL (accessible to everyone)
  if (isPrivacyPage) {
    return <PrivacyPolicyPage />;
  }

  // Show terms of service page for /terms URL (accessible to everyone)
  const isTermsPage = window.location.pathname === '/terms';
  if (isTermsPage) {
    return <TermsOfServicePage />;
  }

  // Show landing page for unauthenticated visitors
  if (!isAuthenticated) {
    return <LandingPage />;
  }

  return (
    <Router>
      <GlobalStyles />

      <Box margin="xxLarge" padding="large">
         <Header />
        <Routes>
          <Route path="/fees" element={trialGated ? <TrialExpiredPage /> : <FeesPage />} />
          <Route path="/fees/create" element={trialGated ? <TrialExpiredPage /> : <CreateEditFeePage />} />
          <Route path="/fees/edit/:id" element={trialGated ? <TrialExpiredPage /> : <CreateEditFeePage />} />
          <Route path="/setup-checkout" element={trialGated ? <TrialExpiredPage /> : <SetupCheckoutPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="*" element={<StartupRedirect />} />
        </Routes>
      </Box>
    </Router>
  );
}

export default App;
